import { LAYOUTS } from '@/App.vue'
import ROUTE_NAMES from './route-names'

const {
  checkout,
  checkoutRegistration,
  checkoutShipping,
  checkoutPayment,
  checkoutConfirmation,
  pageNotFound,
  product,
  demoSizing,
  demo,
  demoForm,
} = ROUTE_NAMES

export default [
  {
    path: `/${checkout}`,
    name: checkout,
    meta: { layout: LAYOUTS.simple },
    component: () => {
      return import(/* webpackChunkName: "checkout-v2" */ '@/views/Checkout.vue')
    },
    children: [
      {
        path: `${checkoutRegistration}`,
        name: checkoutRegistration,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "registration" */ '@/views/Checkout/Registration.vue')
        },
      },
      {
        path: `${checkoutShipping}`,
        name: checkoutShipping,
        meta: { layout: LAYOUTS.simple, modifier: 'bottom-margin' },
        component: () => {
          return import(/* webpackChunkName: "shipping" */ '@/views/Checkout/Shipping.vue')
        },
      },
      {
        path: `${checkoutPayment}`,
        name: checkoutPayment,
        meta: { layout: LAYOUTS.simple, modifier: 'bottom-margin' },
        component: () => {
          return import(/* webpackChunkName: "payment" */ '@/views/Checkout/Payment.vue')
        },
      },
      {
        path: `${checkoutConfirmation}/:orderNumber`,
        name: checkoutConfirmation,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "confirmation" */ '@/views/Checkout/Confirmation.vue')
        },
      },
    ],
  },
  {
    path: `/${product}/:productGroup/:gender?/:colors?`,
    name: product,
    component: () => {
      return import(/* webpackChunkName: "product-page" */ '@/views/ProductPage.vue')
    },
  },
  {
    path: `/${demo}`,
    name: demo,
    meta: { layout: LAYOUTS.simple },
    component: () => {
      return import(/* webpackChunkName: "demo" */ '@/views/Demo.vue')
    },
    children: [
      {
        path: `${demoForm}`,
        name: demoForm,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "demo-form" */ '@/views/demo/DemoForm.vue')
        },
      },
      {
        path: `${demoSizing}`,
        name: demoSizing,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "demo-sizing" */ '@/views/demo/DemoSizing.vue')
        },
      },
    ],
  },
  {
    path: '*',
    name: pageNotFound,
    meta: { layout: LAYOUTS.blank },
    component: () => {
      return import(/* webpackChunkName: "page-not-found" */ '@/views/PageNotFound.vue')
    },
  },
]
